import { connect } from 'react-redux';
import { State } from 'store/types';
import View from './View';
import { fetchPopularSuggestions } from 'store/searchSuggestions/action';


const mapDispatchToProps = {
    fetchPopularSuggestions,
};

const mapStateToProps = (state: State) => {
  const { searchSuggestions } = state;
  const {
      popularSuggestionTypes = [],
  } = searchSuggestions;
  return {
    popularSuggestionTypes: popularSuggestionTypes,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(View);
